export const PAGE_SCROLL_DISABLED_CLASS_NAME = '_scrollDisabled'
